import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import Layout from '../../components/layout';
import { withTranslation } from '../../lib/translate';
import { isDefined } from '../../lib/utils';
import { ApplyPoints } from '../applyPoints';
import './index.css';

class ApplyLoyalty extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		const { __, profile } = this.props;
		const points_value_percentage = isDefined(getConfig().api_config) && isDefined(getConfig().api_config.points_value_percentage) ? getConfig().api_config.points_value_percentage : 0;

		return (
			<Layout color="transparent" title={__('Redeem Loyalty')} backHandler={this.backHandler} scrollY={false} headerWithTitle={true}>
				<div className="absolute-content scrollable-y">
					{!(points_value_percentage == 0 && profile.available_balance == 0) && <ApplyPoints></ApplyPoints>}
				</div>
			</Layout>
		);
	}
}

const stateToProps = (state) => {
	return {
		transactionHistory: state.orders.history || [],
		orderHistory: state.orders.orderHistory || [],
		profile: state.profile.profile,
	};
};

export default withRouter(withTranslation(connect(stateToProps)(ApplyLoyalty)));
